module.exports = __webpack_public_path__ + "img/ilustraciones_rapido.4c7f1b0b.svg";